// src/seo/seoContext.ts
import { normalizeEnvironment } from './core/urls';

export interface SeoContext {
  environment: string;
  siteUrl?: string;
}

/**
 * The build-time environment every metadata/canonical/robots decision keys off.
 *
 * `REACT_APP_ENVIRONMENT` is already set per Vercel project
 * (production / staging / qa). `REACT_APP_SEO_SITE_URL` is an optional override
 * for preview deployments and local testing; when unset, the canonical origin
 * comes from the environment's default in `core/urls.js`.
 *
 * Anything that is not literally "production" normalizes to a non-production
 * environment, which forces `noindex` everywhere — fail closed by default.
 */
export function getSeoContext(): SeoContext {
  return {
    environment: normalizeEnvironment(process.env.REACT_APP_ENVIRONMENT),
    siteUrl: process.env.REACT_APP_SEO_SITE_URL || undefined,
  };
}

/** True only in the production web environment. */
export function isIndexableEnvironment(): boolean {
  return getSeoContext().environment === 'production';
}
